@import "~@govbr-ds/core/src/components/message/message";

:host {
  display: block;

  .icon-space {
    margin-right: var(--spacing-scale-half);
  }

  .br-message.success .close br-button,
  .br-message.danger .close br-button,
  .br-message.info .close br-button {
    --interactive: var(--message-color-icon);
  }

  .br-message.success .close br-button {
    --interactive-rgb: var(--success-rgb);
  }

  .br-message.danger .close br-button {
    --interactive-rgb: var(--danger-rgb);
  }

  .br-message.info .close br-button {
    --interactive-rgb: var(--info-rgb);
  }

  .br-message.warning .close br-button {
    --interactive: var(--color);
    --interactive-rgb: var(--color-rgb);
  }
}
